module.exports = __webpack_public_path__ + "img/therapeutic-alliance.ba952377.svg";